import doT from 'dot';
const doctors = doT.template(`
<div class="pb-doctors__wrapper col-12">
	<div class="pb-subtitle">Select a doctor</div>
	<select class="pb-select pb-select--doctors">
		<option value="" selected>Any</option>
		{{~it.staff :value:index}}
		<option value={{=value._id}}>{{=value.salutation}} {{=value.first_name}} {{=value.last_name}}</option>
		{{~}}
	</select>
</div>
`);

const submitLabel = doT.template(`
	Request Appointment for {{=it.aptDate}} at {{=it.aptTime}} with {{=it.docName}}.
`);

export { doctors, submitLabel };



// WEBPACK FOOTER //
// ./public/src/templates/doctors.js